module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"question":"Are you sure you want to delete this file?","title":"Delete File"},"fr":{"question":"Êtes-vous certain de vouloir supprimer ce fichier?","title":"Supprimer le fichier"}}')
  delete Component.options._Ctor
}
